import { createContext, useContext, useMemo, useState, type ReactNode } from 'react';

interface PatchLogGateValue {
  /**
   * True while the patch-log modal owns the screen (or is still deciding
   * whether it will). Other auto-starting surfaces — the onboarding tour —
   * read this to hold off, so two overlays never fight for the user.
   */
  isBlocking: boolean;
  setBlocking: (blocking: boolean) => void;
}

const PatchLogGateContext = createContext<PatchLogGateValue | null>(null);

/**
 * Sits ABOVE anything that must yield to the patch-log modal (TourProvider),
 * so consumers can read the flag without depending on the gate component.
 */
export const PatchLogGateProvider = ({ children }: { children: ReactNode }) => {
  const [isBlocking, setBlocking] = useState(false);
  const value = useMemo<PatchLogGateValue>(() => ({ isBlocking, setBlocking }), [isBlocking]);
  return <PatchLogGateContext.Provider value={value}>{children}</PatchLogGateContext.Provider>;
};

/** Null outside the provider — isolated surfaces and tests tolerate that. */
export const useOptionalPatchLogGate = () => useContext(PatchLogGateContext);
